export const ACHIEVEMENTS = {
  // ID des Erfolgs
  noviceTracker: {
    title: "Novice Tracker",
    description: "Log your first 100 wishes.",
    title_de: "Anfänger-Tracker",
    description_de: "Logge deine ersten 100 Gebete.",
    icon: "📜",
    check: (state, {calculateComprehensiveStats}) => {
      const charPulls =
        state.character1.totalPulls + state.character2.totalPulls;
      const weaponPulls =
        (state.weapon?.pity || 0) +
        calculateComprehensiveStats(state.weapon?.history || [])
          .totalPullsInHistory;
      const standardPulls =
        (state.standard?.pity || 0) +
        calculateComprehensiveStats(state.standard?.history || [])
          .totalPullsInHistory;
      const chronicledPulls =
        (state.chronicled?.pity || 0) +
        calculateComprehensiveStats(state.chronicled?.history || [])
          .totalPullsInHistory;
      const totalWishes =
        charPulls + weaponPulls + standardPulls + chronicledPulls;
      return totalWishes >= 100;
    },
  },
  adeptCounter: {
    title: "Adept Counter",
    description: "Log a total of 500 wishes.",
    title_de: "Geübter Zähler",
    description_de: "Logge insgesamt 500 Gebete.",
    icon: "📚",
    check: (state, {calculateComprehensiveStats}) => {
      const charPulls =
        state.character1.totalPulls + state.character2.totalPulls;
      const weaponPulls =
        (state.weapon?.pity || 0) +
        calculateComprehensiveStats(state.weapon?.history || [])
          .totalPullsInHistory;
      const standardPulls =
        (state.standard?.pity || 0) +
        calculateComprehensiveStats(state.standard?.history || [])
          .totalPullsInHistory;
      const chronicledPulls =
        (state.chronicled?.pity || 0) +
        calculateComprehensiveStats(state.chronicled?.history || [])
          .totalPullsInHistory;
      const totalWishes =
        charPulls + weaponPulls + standardPulls + chronicledPulls;
      return totalWishes >= 500;
    },
  },
  plannersVision: {
    title: "Planner's Vision",
    description: "Use the Goal Planner for the first time.",
    title_de: "Vision des Planers",
    description_de: "Benutze den Ziel-Planer zum ersten Mal.",
    icon: "🗺️",
    // Dieser Erfolg wird manuell ausgelöst, daher keine check-Funktion
    check: null,
  },
  archivistOfTeyvat: {
    title: "Archivist of Teyvat",
    description:
      "Log at least one 4-star or 5-star pull on 3 different banner types.",
    title_de: "Archivar von Teyvat",
    description_de:
      "Logge mindestens einen 4- oder 5-Sterne-Zug auf 3 verschiedenen Bannertypen.",
    icon: "🏛️",
    check: (state) => {
      const bannerTypesWithPulls = [
        "character1",
        "character2",
        "weapon",
        "standard",
        "chronicled",
      ];
      const count = bannerTypesWithPulls.reduce((acc, banner) => {
        if (state[banner] && state[banner].history.length > 0) {
          return acc + 1;
        }
        return acc;
      }, 0);
      return count >= 3;
    },
  },
  slimeSquisher: {
    title: "Slime Squisher",
    description: "Achieve a highscore of 100,000 points in Slime Breaker.",
    title_de: "Schleim-quetscher",
    description_de:
      "Erreiche einen Highscore von 100.000 Punkten in Schleim-Brecher.",
    icon: "💥",
    check: (state) => state.minigame.highScore >= 100000,
  },
  adeptAdventurer: {
    title: "Adept Adventurer",
    description: "Reach Round 101 in Slime Breaker.",
    title_de: "Geübter Abenteurer",
    description_de: "Erreiche Runde 101 in Schleim-Brecher.",
    icon: "🏅",
    check: (state) => state.minigame.turnCount >= 101,
  },
  treasureHunter: {
    title: "Treasure Hunter",
    description: "Achieve a highscore of 500,000 points in Slime Breaker.",
    title_de: "Schatzjäger",
    description_de:
      "Erreiche einen Highscore von 500.000 Punkten in Schleim-Brecher.",
    icon: "💎",
    check: (state) => state.minigame.highScore >= 500000,
  },
  comboNovice: {
    title: "Combo Novice",
    description: "Achieve a 100-hit combo in Slime Breaker.",
    title_de: "Kombo-Neuling",
    description_de: "Erreiche eine 100-Hit-Kombo in Schleim-Brecher.",
    icon: "✨",
    check: (state) => (state.minigame.maxCombo || 0) >= 100,
  },
  comboAdept: {
    title: "Combo Adept",
    description: "Achieve a 500-hit combo in Slime Breaker.",
    title_de: "Kombo-Kenner",
    description_de: "Erreiche eine 500-Hit-Kombo in Schleim-Brecher.",
    icon: "🌟",
    check: (state) => (state.minigame.maxCombo || 0) >= 500,
  },
  comboMaster: {
    title: "Combo Master",
    description: "Achieve a 1000-hit combo in Slime Breaker.",
    title_de: "Kombo-Meister",
    description_de: "Erreiche eine 1000-Hit-Kombo in Schleim-Brecher.",
    icon: "💫",
    check: (state) => (state.minigame.maxCombo || 0) >= 1000,
  },
};